Vue.asyncComponent('ak-wrapper', {

}, 'wrappers/ak-wrapper.html');